import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import App from './App';
import { recoverFromMissingPageCode } from './shared/utils/lazyPage';

// A page's stylesheet or shared chunk that vanished in a deploy fails here
// rather than in the page import.
window.addEventListener('vite:preloadError', (event) => {
  if (recoverFromMissingPageCode(event.payload)) event.preventDefault();
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
